import React from 'react';
import styled from '@emotion/styled';
import { theme } from '@styles';
import { MOUNTAIN_MEADOW, WHITE, OUTER_SPACE } from '@constants';
import AppleStore from '@components/AppleStore';
import GoogleStore from '@components/GoogleStore';

const { breakpoints } = theme;

interface StickyMobileCTAProps {
  ios_app_link: string;
  android_app_link: string;
  ios_app_id: string;
  android_app_id: string;
}

const StickyMobileCTA: React.FC<StickyMobileCTAProps> = ({
  ios_app_link,
  android_app_link,
  ios_app_id,
  android_app_id
}) => {
  return (
    <StickyWrapper>
      <CTAContainer>
        <AppStoreSection>
          <AppStoreWrapper>
            <AppleStore url={ios_app_link} id={ios_app_id} width={120} height={36} />
          </AppStoreWrapper>
          <GoogleStoreWrapper>
            <GoogleStore url={android_app_link} id={android_app_id} width={120} height={36} />
          </GoogleStoreWrapper>
        </AppStoreSection>
      </CTAContainer>
    </StickyWrapper>
  );
};

export default StickyMobileCTA;

const StickyWrapper = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: ${WHITE};
  border-top: 1px solid rgba(17, 204, 136, 0.2);
  box-shadow: 0px -4px 10px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  padding: 12px 16px;
  
  @media screen and (min-width: ${breakpoints.smallLaptop}) {
    display: none;
  }
`;

const CTAContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 500px;
  margin: 0 auto;
`;

const AppStoreSection = styled.div`
  display: flex;
  gap: 8px;
  max-width: 250px;
  width: 100%;
`;

const AppStoreWrapper = styled.div`
  flex: 1;
  
  a {
    display: block;
    width: 100%;
  }
  
  svg {
    width: 100%;
    height: 36px;
  }
`;

const GoogleStoreWrapper = styled.div`
  flex: 1;
  
  a {
    display: block;
    width: 100%;
  }
  
  svg {
    width: 100%;
    height: 36px;
  }
`; 